import { useState, useEffect } from "react";

function Overlay({ beat }) {
  const atTop = beat.position === "top";
  return (
    <div
      className={`absolute inset-x-0 ${atTop ? "top-0 bg-gradient-to-b" : "bottom-0 bg-gradient-to-t"} from-black/85 via-black/30 to-transparent pointer-events-none`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="space-y-2 md:space-y-3">
          {beat.lines.map((l, i) => {
            const t = typeof l === "string" ? l : l.t;
            const accent = typeof l === "object" && l.accent;
            return (
              <p
                key={`${i}-${t}`}
                className={`font-heading text-2xl sm:text-3xl md:text-4xl font-light tracking-tight leading-[1.2] ${accent ? "text-accent" : "text-white"}`}
              >
                {t}
              </p>
            );
          })}
        </div>
        {beat.caption && (
          <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-zinc-400 mt-4">
            {beat.caption}
          </p>
        )}
      </div>
    </div>
  );
}

export function BannerGallery({ beats, interval = 4200, testId = "about-banner-gallery" }) {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => setIdx((x) => (x + 1) % beats.length), interval);
    return () => clearInterval(id);
  }, [beats.length, interval, paused]);

  return (
    <section
      data-testid={testId}
      className="relative w-full bg-black border-y border-zinc-800 overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="relative w-full" style={{ aspectRatio: "16 / 9", maxHeight: "78vh" }}>
        {beats.map((b, i) => (
          <div
            key={b.testId || i}
            className="absolute inset-0 transition-opacity duration-[900ms] ease-in-out"
            style={{ opacity: idx === i ? 1 : 0 }}
          >
            <img loading="lazy"
              src={b.src}
              alt={b.alt}
              className="absolute inset-0 w-full h-full object-contain"
            />
            <Overlay beat={b} />
          </div>
        ))}

        <div className="absolute top-5 right-6 flex gap-2 z-10">
          {beats.map((b, i) => (
            <button
              key={b.testId || i}
              type="button"
              onClick={() => setIdx(i)}
              aria-label={`Show slide ${i + 1}`}
              data-testid={`about-gallery-dot-${i}`}
              className="w-2.5 h-2.5 rounded-full transition-colors"
              style={{ background: idx === i ? "#ffffff" : "rgba(255,255,255,0.35)" }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

// Per-chapter banners have been consolidated into a single BannerGallery.
export function BannerBeat() {
  return null;
}
